import SifAuAdapter from './base';

export default class Zone extends SifAuAdapter {
  modelNamePlural = 'zones';
}
